import { events } from "@/mocks/guaData";

export default function FeaturedStory() {
  const story = events.find((e) => e.featured) ?? events[0];
  const related = events.filter((e) => e.id !== story.id).slice(0, 3);

  return (
    <section id="feature" className="scroll-mt-24 bg-background-950">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <p className="flex items-center gap-2 text-sm font-semibold text-accent-400">
          <span className="flex h-5 w-5 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
            <i className="ri-vip-crown-2-line text-[13px]"></i>
          </span>
          FEATURED&nbsp;STORY
        </p>
        <div className="mt-3 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <h2 className="text-2xl font-bold text-background-50 md:text-4xl">热瓜专题 · 不只聊个热闹</h2>
          <p className="text-sm text-background-200">深入拆解现象背后的来龙去脉，把瓜吃明白。</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <div className="relative min-h-[260px] overflow-hidden rounded-lg lg:col-span-2">
            <img
              src={story.cover}
              alt={`${story.title} 热瓜专题封面`}
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent"></div>
            <div className="absolute right-4 bottom-4 left-4 flex flex-wrap gap-2">
              <span className="rounded-md bg-accent-500 px-2.5 py-1 text-xs font-semibold text-foreground-950">
                {story.catLabel}
              </span>
              <span className="rounded-md bg-background-50/20 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
                {story.time.replace("2026-09-0", "09-0")} 更新
              </span>
            </div>
          </div>

          <div className="flex flex-col rounded-lg bg-background-50 p-6 md:p-8 lg:col-span-3">
            <div className="flex items-center gap-2 text-xs text-foreground-500">
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-pen-nib-line text-[13px]"></i>
              </span>
              吃瓜榜单 · 编辑部观察
              <span className="mx-1 text-background-300">/</span>
              阅读约 4 分钟
            </div>
            <h3 className="mt-4 text-xl leading-snug font-bold text-foreground-950 md:text-2xl">{story.title}</h3>

            <div className="mt-5 flex flex-col gap-4">
              {story.featuredBody?.map((p, i) => (
                <p key={i} className="text-sm leading-7 text-foreground-700 md:text-base">
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-6 rounded-lg bg-secondary-100 p-5">
              <p className="text-xs font-semibold tracking-wide text-secondary-900 uppercase">数据速览</p>
              <ul className="mt-3 flex flex-col gap-2">
                {story.highlight?.map((h) => (
                  <li key={h} className="flex items-center gap-2 text-sm text-foreground-800">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-primary-100 text-primary-600">
                      <i className="ri-check-line text-[13px]"></i>
                    </span>
                    {h}
                  </li>
                ))}
              </ul>
            </div>

            <a
              href="#feed"
              className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              返回瓜田，看完整榜单
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-[15px]"></i>
              </span>
            </a>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
          {related.map((r) => (
            <a
              key={r.id}
              href="#feed"
              className="group flex items-center gap-3 rounded-lg border border-background-50/10 bg-background-50/5 px-4 py-3 transition-colors hover:border-accent-500/50 hover:bg-background-50/10"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-50/10 text-accent-400">
                <i className="ri-article-line text-[16px]"></i>
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-background-50 group-hover:text-accent-400">{r.title}</p>
                <p className="text-xs text-background-200">{r.catLabel} · 热度 {r.heat}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}